import { FC, useCallback } from "react";
import { OrderedListExtension } from "@remirror/extension-list";
import { useActive, useCommands } from "@remirror/react";
import { CommandButton, CommandButtonProps } from "@remirror/react-ui";

export interface ToggleOrderedListButtonProps
  extends Omit<
    CommandButtonProps,
    "commandName" | "active" | "enabled" | "attrs" | "onSelect"
  > {
  onBlur: () => void;
}

export const ToggleOrderedListButton: FC<ToggleOrderedListButtonProps> = (
  props,
) => {
  const { toggleOrderedList } = useCommands<OrderedListExtension>();

  const handleSelect = useCallback(() => {
    if (toggleOrderedList.enabled()) {
      toggleOrderedList();
      props.onBlur();
    }
  }, [props, toggleOrderedList]);

  const active = useActive<OrderedListExtension>().orderedList();
  const enabled = toggleOrderedList.enabled();

  return (
    <CommandButton
      {...props}
      commandName="toggleOrderedList"
      active={active}
      enabled={enabled}
      onSelect={handleSelect}
    />
  );
};
